const classes = {
  adsContainer: {
    padding: '5px',
    textAlign: 'center',
    minHeight: 290,
  },
  adsContainerImg: {
    width: '100%',
    height: '100%',
  },
  baseAdsContainer: {
    display: 'flex',
    flex: 1,
  },
  baseAdsContainerImg: {
    minWidth: '100%',
  },
  baseAdsHeight: (height:number) =>
    ({
      height,
    }),
  disabled: {
    pointEvents: 'none',
    cursor: 'default',
  },
  dynamicHeight: (height: number, legendHeight:number) =>
    ({
      height: (height * 3) / 4 - legendHeight,
    }),
};

export default classes;
